import * as QueryStringHelper from './QueryStringHelper';

export function getReferrerEncoded() {
    return QueryStringHelper.getQueryStringParameter('_r') || encodeURIComponent(document.referrer);
}
